import React from 'react';

import { Flex, FlexItem, FlexBlock, Button } from '@wordpress/components';
import StepTitle from './elements/StepTitle';
import PaymentDetails from './elements/PaymentDetails';
import { useStripe } from '@stripe/react-stripe-js';

const Order = (props) => {
	const stripe = useStripe();
	// console.log("props.coupon:", props.coupon);
	return (
		<Flex className="step-holder">
			{/* TITLE & DESCRIPTION */}
			<StepTitle>Upgrade to Premium</StepTitle>
			<StepTitle className="step-description">
				Billed {props.plan.text.replace('Subscription', '')}
			</StepTitle>
			<br />

			{/* CARD DETAILS */}
			<PaymentDetails
				card={props.card}
				changeFunction={() => props.cardFunction()}
			/>

			{/* ORDER DETAILS */}
			<Flex className="section-title">Your order</Flex>
			<div
				style={{
					width: 'calc(100% - 20px)',
					margin: 0,
					paddingLeft: '10px',
					paddingRight: '10px',
					borderRadius: '2px',
					backgroundColor: '#f5f6f9',
				}}
			>
				{/* Plan price */}
				<Flex className="section-row invoice-row">
					<FlexItem>
						{props.widgetName + ' - ' + props.plan.text}
					</FlexItem>
					<FlexItem>
						{props.plan.price ? '$' + props.plan.price : ''}{' '}
					</FlexItem>
				</Flex>

				{/* Coupon price */}
				{props.coupon && props.coupon.percent_off && (
					<Flex className="section-row invoice-row">
						<FlexItem>Coupon: #{props.coupon.name}</FlexItem>
						<FlexItem>
							{props.coupon.percent_off +
								'% off, ' +
								(props.coupon.max_redemptions
									? props.coupon.max_redemptions +
									  ' time' +
									  (props.coupon.max_redemptions > 1
											? 's'
											: '')
									: 'forever')}
						</FlexItem>
					</Flex>
				)}
				{/* Total */}
				<Flex
					className="section-row invoice-row"
					style={{ border: 'none' }}
				>
					<FlexItem>
						<b>Total</b>
					</FlexItem>
					<FlexItem>
						<b>
							$
							{Math.max(
								0,
								props.plan.price -
									(props.coupon &&
									(props.coupon.percent_off ||
										props.coupon.amount_off)
										? props.coupon.percent_off
											? (props.coupon.percent_off / 100) *
											  props.plan.price
											: props.coupon.amount_off
										: 0)
							)}
						</b>
					</FlexItem>
				</Flex>
			</div>

			<FlexBlock />

			{/* Submit buttons */}
			<Flex className="step-footer">
				<FlexBlock />
				<Button isSecondary onClick={() => props.couponFunction()}>
					I have a coupon
				</Button>
				<Button isPrimary onClick={() => props.finishFunction(stripe)}>
					Subscribe
				</Button>
			</Flex>
		</Flex>
	);
};

export default Order;
